import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "material-loan-vendor",
  value: "Material_On_Loan_To_Vendor",
  labelKey: "inventory.transferMaterialOnLoanToVendor",
  party: "vendor",
};

export function MaterialOnLoanToVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
